module.exports = __webpack_public_path__ + "static/media/duedilligence.fabdbed6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/duedilligence.svg
// module id = 154
// module chunks = 0